/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientServicesDefault } from '../models/client-services-default';
import { CollectedService } from '../models/collected-service';
import { getCollectedServicesForCientAndDateIdDateGet$Json } from '../fn/service/get-collected-services-for-cient-and-date-id-date-get-json';
import { GetCollectedServicesForCientAndDateIdDateGet$Json$Params } from '../fn/service/get-collected-services-for-cient-and-date-id-date-get-json';
import { getCollectedServicesForCientAndDateIdDateGet$Plain } from '../fn/service/get-collected-services-for-cient-and-date-id-date-get-plain';
import { GetCollectedServicesForCientAndDateIdDateGet$Plain$Params } from '../fn/service/get-collected-services-for-cient-and-date-id-date-get-plain';
import { getDefaultServicesForCientIdGet$Json } from '../fn/service/get-default-services-for-cient-id-get-json';
import { GetDefaultServicesForCientIdGet$Json$Params } from '../fn/service/get-default-services-for-cient-id-get-json';
import { getDefaultServicesForCientIdGet$Plain } from '../fn/service/get-default-services-for-cient-id-get-plain';
import { GetDefaultServicesForCientIdGet$Plain$Params } from '../fn/service/get-default-services-for-cient-id-get-plain';

@Injectable({ providedIn: 'root' })
export class ServiceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDefaultServicesForCientIdGet()` */
  static readonly GetDefaultServicesForCientIdGetPath = '/GetDefaultServicesForCient/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultServicesForCientIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultServicesForCientIdGet$Plain$Response(params: GetDefaultServicesForCientIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientServicesDefault>>> {
    return getDefaultServicesForCientIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaultServicesForCientIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultServicesForCientIdGet$Plain(params: GetDefaultServicesForCientIdGet$Plain$Params, context?: HttpContext): Observable<Array<ClientServicesDefault>> {
    return this.getDefaultServicesForCientIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientServicesDefault>>): Array<ClientServicesDefault> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultServicesForCientIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultServicesForCientIdGet$Json$Response(params: GetDefaultServicesForCientIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientServicesDefault>>> {
    return getDefaultServicesForCientIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaultServicesForCientIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultServicesForCientIdGet$Json(params: GetDefaultServicesForCientIdGet$Json$Params, context?: HttpContext): Observable<Array<ClientServicesDefault>> {
    return this.getDefaultServicesForCientIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientServicesDefault>>): Array<ClientServicesDefault> => r.body)
    );
  }

  /** Path part for operation `getCollectedServicesForCientAndDateIdDateGet()` */
  static readonly GetCollectedServicesForCientAndDateIdDateGetPath = '/GetCollectedServicesForCientAndDate/{id}/{date}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCollectedServicesForCientAndDateIdDateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectedServicesForCientAndDateIdDateGet$Plain$Response(params: GetCollectedServicesForCientAndDateIdDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollectedService>>> {
    return getCollectedServicesForCientAndDateIdDateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCollectedServicesForCientAndDateIdDateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectedServicesForCientAndDateIdDateGet$Plain(params: GetCollectedServicesForCientAndDateIdDateGet$Plain$Params, context?: HttpContext): Observable<Array<CollectedService>> {
    return this.getCollectedServicesForCientAndDateIdDateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CollectedService>>): Array<CollectedService> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCollectedServicesForCientAndDateIdDateGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectedServicesForCientAndDateIdDateGet$Json$Response(params: GetCollectedServicesForCientAndDateIdDateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollectedService>>> {
    return getCollectedServicesForCientAndDateIdDateGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCollectedServicesForCientAndDateIdDateGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectedServicesForCientAndDateIdDateGet$Json(params: GetCollectedServicesForCientAndDateIdDateGet$Json$Params, context?: HttpContext): Observable<Array<CollectedService>> {
    return this.getCollectedServicesForCientAndDateIdDateGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CollectedService>>): Array<CollectedService> => r.body)
    );
  }

}
